import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__collections } from '../STATE__collections';

export const local_collection_set_special_collections_by_workspace_id = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.SET_SPECIAL_COLLECTIONS_BY_WORKSPACE_ID,
  payload,
});

export const init_local_collection_set_special_collections_by_workspace_id = (state: STATE__collections, action: PayloadAction<string>) => {
  let workspace_id = action.payload;

  state.collection_favorites =
    Array.from(state.collections_map.values()).find(item => item.type == ENUM__workspace_entity.COLLECTION_FAVORITES && item.workspace_id == workspace_id) ||
    DTO__collection.CREATE_STUB();

  state.collection_generated =
    Array.from(state.collections_map.values()).find(item => item.type == ENUM__workspace_entity.COLLECTION_GENERATED && item.workspace_id == workspace_id) ||
    DTO__collection.CREATE_STUB();

  state.collection_viewed_on_search =
    Array.from(state.collections_map.values()).find(
      item => item.type == ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH && item.workspace_id == workspace_id,
    ) || DTO__collection.CREATE_STUB();

  state.collection_uploads =
    Array.from(state.collections_map.values()).find(item => item.type == ENUM__workspace_entity.COLLECTION_UPLOADS && item.workspace_id == workspace_id) ||
    DTO__collection.CREATE_STUB();
};
